import React from "react";
import NarratorIntonation from "../intonation/NarratorIntonation";

const PresentationNarratorPanel = ({
  segment,
  subject,
  file,
  handleLaneWordClick,
  broadcastTime,
  audioref,
  visualizationView,
  rate,
  setRate,
}) => {
  if (!segment?.words?.length) return null;

  return (
    <section className="rounded-3xl border border-white/40 bg-white/80 backdrop-blur-sm shadow-lg shadow-blue-500/5 overflow-hidden h-full">
      <div className="px-4  border-b border-white/30 bg-gradient-to-r from-white/50 to-white/10">
        <div className="flex items-center justify-between gap-4">
          <div className="min-w-0">
            <div className="text-[11px] uppercase tracking-[0.18em] text-blue-500/80 mb-1">
              Narrator
            </div>
            
          </div>

          <div className="flex items-center gap-2 shrink-0">
            <span className="hidden sm:inline text-[11px] uppercase tracking-[0.14em] text-gray-400 mr-1">
              Speed
            </span>

            {[0.25, 0.5, 1].map((speed) => {
              const active = rate === speed;

              return (
                <button
                  key={speed}
                  type="button"
                  onClick={() => {
                    setRate(speed);
                    if (audioref.current) {
                      audioref.current.playbackRate = speed;
                    }
                  }}
                  className={[
                    "px-3 py-1.5 rounded-lg text-sm font-semibold transition-all border",
                    active
                      ? "bg-blue-500 text-white border-blue-400 shadow"
                      : "bg-white/70 text-gray-700 border-white/50 hover:bg-white",
                  ].join(" ")}
                >
                  {speed}x
                </button>
              );
            })}
          </div>
        </div>
      </div>

      <div className="p-3">
        <div className="rounded-2xl border border-white/40 bg-white/60 overflow-hidden">
          <div className="sm:p-3">
            <div className="h-[250px] sm:h-[270px]">
              <NarratorIntonation
                subject={subject}
                file={file}
                segment={segment}
                onWordClick={handleLaneWordClick}
                broadcastTime={broadcastTime}
                audioRef={audioref}
                view={visualizationView}
                speed={rate}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PresentationNarratorPanel;